import { MagnifyingGlassIcon } from '@radix-ui/react-icons'
import { TextField } from '@radix-ui/themes'
import React from 'react'
import styled from 'styled-components'

const StyledTextFieldRoot = styled(TextField.Root)`
  min-height: 2rem;
  background-color: ${({ theme }) => theme.forecast.defaultButton};
  border-radius: 4px;
  &:hover {
    background-color: ${({ theme }) => theme.forecast.hoverButton} !important;
  }
`

const StyledTextFieldSlot = styled(TextField.Slot)`
  padding: 4px;
`

interface SearchBarProps {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  style?: React.CSSProperties
  className?: string
  onKeyDown?: (e: React.KeyboardEvent) => void
}

export const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  placeholder = 'Search',
  style,
  className,
  onKeyDown,
}) => {
  return (
    <StyledTextFieldRoot
      placeholder={placeholder}
      variant='soft'
      value={value}
      onChange={onChange}
      style={style}
      className={className}
      onKeyDown={onKeyDown}>
      <StyledTextFieldSlot>
        <MagnifyingGlassIcon height='16' width='16' />
      </StyledTextFieldSlot>
    </StyledTextFieldRoot>
  )
}

export default SearchBar
